import gql from 'graphql-tag'
import { paymentMethodInfo } from './fragments.gql'

export const PAYMENT_METHODS_QUERY = gql`
  query PaymentMethods {
    paymentMethods {
      ${paymentMethodInfo}
    }
  }
`

export const DEFAULT_PAYMENT_METHOD_QUERY = gql`
  query PaymentMethods {
    defaultMethod {
      ${paymentMethodInfo}
    }
  }
`

export const ADD_PAYMENT_METHOD_MUTATION = gql`
  mutation AddPaymentMethod($data: PaymentMethodCreateData!) {
    addPaymentMethod(data: $data) {
      ${paymentMethodInfo}
    }
  }
`

export const DELETE_PAYMENT_METHOD_MUTATION = gql`
  mutation DletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id) {
      ${paymentMethodInfo}
    }
  }
`
